// src/components/DeleteSelectionGroupModal/DeleteSelectionGroupModal.tsx

import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { DeleteSelectionGroup } from '../../../../../../../../crud/menu_api/selection_groups';
import { toast } from 'react-toastify';

interface SelectionGroupType {
  readonly selection_group_id: number;
  selection_group_name: string;
  selection_group_description?: string;
  local_id: number;
  items_affected?: Array<{
    item_id: number;
    item_name: string;
  }>;
  items_contained?: Array<{
    item_id: number;
    item_name: string;
  }>;
}

interface DeleteSelectionGroupModalProps {
  show: boolean;
  handleClose: () => void;
  sg: SelectionGroupType;
  setData: (data: SelectionGroupType[]) => void;
  data: SelectionGroupType[];
}

const DeleteSelectionGroupModal: React.FC<DeleteSelectionGroupModalProps> = ({
  show,
  handleClose,
  sg,
  setData,
  data,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleDelete = () => {
    setLoading(true);
    DeleteSelectionGroup(sg.selection_group_id)
      .then((response) => {
        toast.success('Grupo de selección eliminado exitosamente.');
        // Filtrar el grupo eliminado de la lista
        const updatedData = data.filter(
          (group) => group.selection_group_id !== sg.selection_group_id
        );
        setData(updatedData);
        handleClose();
      })
      .catch((error) => {
        console.error('Error eliminando el grupo de selección', error);
        const message =
          error.response?.data?.message || 'Error al eliminar el grupo de selección.';
        toast.error(message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header >
        <Modal.Title>Eliminar Grupo de Selección</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
        <p>
          ¿Estás seguro de que deseas eliminar el grupo de selección{' '}
          <strong>{sg.selection_group_name}</strong>?
        </p>
        
        <p>
          Esta acción no se puede deshacer y se eliminarán todos los ítems asociados a este
          grupo.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={loading}>
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{' '}
              Eliminando...
            </>
          ) : (
            'Eliminar'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteSelectionGroupModal;
